import { create } from 'zustand';

export const useToastStore = create((set, get) => ({
 toasts: [],

 addToast: (message, type = 'info', duration = 4000) => {
 const id = Date.now().toString() + Math.random().toString(36).slice(2);
 const toast = { id, message, type, createdAt: Date.now() };
 
 set((state) => ({ toasts: [...state.toasts, toast] }));

 // Auto-dismiss
 setTimeout(() => {
 get().removeToast(id);
 }, duration);

 return id;
 },

 removeToast: (id) => {
 set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
 },

 clearAll: () => set({ toasts: [] }),
}));
